import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { UserGroupState } from '@reducers/user-group';
import { UserGroupsState } from '@reducers/user-groups';

// Users List
export const getUserGroups = (state: RootState): UserGroupsState => state.userGroups;
export const getUserGroupsData = createSelector(getUserGroups, (group) => group?.data);
export const getUserGroupsItems = createSelector(getUserGroups, (group) => group?.data?.items);
export const getUserGroupsTotal = createSelector(getUserGroups, (group) => group?.data?.total);
export const getUserGroupsError = createSelector(getUserGroups, (group) => group?.error as Error);
export const getUserGroupsFilter = createSelector(getUserGroups, (group) => group?.filter);
export const getUserGroupsLoading = createSelector(getUserGroups, (group) => group?.loading);
export const getCreatedUserGroupId = createSelector(getUserGroups, (group) => group?.createdUserGroupId);

// User Item
export const getUserGroup = (state: RootState): UserGroupState => state.userGroup;
export const getUserGroupData = createSelector(getUserGroup, (group) => group?.data);
export const getUserGroupLoading = createSelector(getUserGroup, (group) => group?.loading);
